import { Search } from 'lucide-react'

interface AlbumFilterProps {
  filter: {
    query: string
    genre: string
    mediaType: string
    sortBy: string
  }
  onFilterChange: (filter: any) => void
}

export function AlbumFilter({ filter, onFilterChange }: AlbumFilterProps) {
  return (
    <div className="flex gap-4 items-center flex-wrap">
      <div className="relative flex-1 max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <input
          type="text"
          placeholder="作品名で検索..."
          value={filter.query}
          onChange={(e) => onFilterChange({ ...filter, query: e.target.value })}
          className="w-full pl-10 pr-4 py-2 border border-border rounded-md bg-background"
        />
      </div>

      <select
        value={filter.mediaType}
        onChange={(e) => onFilterChange({ ...filter, mediaType: e.target.value })}
        className="px-4 py-2 border border-border rounded-md bg-background"
      >
        <option value="">すべて</option>
        <option value="movie">映画</option>
        <option value="tv">TV</option>
      </select>

      <select
        value={filter.sortBy}
        onChange={(e) => onFilterChange({ ...filter, sortBy: e.target.value })}
        className="px-4 py-2 border border-border rounded-md bg-background"
      >
        <option value="view_count">視聴回数順</option>
        <option value="last_watched">最近視聴した順</option>
        <option value="name">タイトル順</option>
      </select>
    </div>
  )
}
